<template>

  <header class="flex flex-col items-center justify-center bg-cover bg-center bg-no-repeat"  :style="{ backgroundImage: 'url(' + require(`@/assets/background.png`) + ')' }">
  
    <div class="flex flex-col items-center my-10">
      <img class="object-contain w-12/12 md:w-8/12 " src="@/assets/logo.png" />
      
      <div class="flex flex-col md:flex-row gap-1 md:gap-4 pt-6">
        <router-link to="/" class="px-5 py-2 mt-3 border border-white bg-transparent text-white font-semibold hover:bg-blue-950 hover:text-white rounded-md" >
          <i class="pi pi-check mr-2"></i>ACREDITARME
        </router-link>
        <router-link to="/credenciales" class="px-5 py-2 mt-3 border border-white bg-transparent text-white font-semibold hover:bg-blue-950 hover:text-white rounded-md" >
          <i class="pi pi-check mr-2"></i>YA ME ACREDITÉ
        </router-link>

      </div>

    </div>

  </header>


</template>

<script>
import VueScrollTo from 'vue-scrollto';

export default {
  methods: {
    scrollToForm() {
      VueScrollTo.scrollTo('#formulario', 500, {
        easing: 'ease-in-out',
      });
    },
  },  
}

</script>